import React, { useContext } from 'react'
import Badge from '@components/ui/Badge'
import ProductType from '@components/ui/ProductType'
import styles from './styles.module.scss'
import CollectionContext from '../collectionContext'

type HeroProps = {
  productTypes: string[]
  children: React.ReactNode
  collectionHero?: {
    badge: {
      title: string
    }
  }
  title: string
  byline?: string
}

const Hero = ({
  title,
  byline,
  collectionHero,
  productTypes,
  children
}: HeroProps) => {
  const { hasMultipleProductTypes } = useContext(CollectionContext)
  const isTitleAProductType =
    hasMultipleProductTypes && productTypes.includes(title)

  return (
    <section className={styles.hero}>
      <div className={styles.hero__container}>
        <div className={styles.hero__headings}>
          {collectionHero?.badge && (
            <Badge classes={styles.hero__badge} {...collectionHero.badge} />
          )}
          {byline && <h1 className={styles.hero__byline}>{byline}</h1>}
          <h2 className={styles.hero__title}>
            <ProductType text={title} />
            {isTitleAProductType ? ' collection' : ''}
          </h2>
        </div>
        <div className={styles.hero__filters}>{children}</div>
      </div>
    </section>
  )
}

export default Hero
